import { useState } from "react";
import UserProfileDialog from "./UserProfileDialog";
import UserAvatar from "./UserAvatar";

const UserElement = ({
  user,
  selectedUserID,
  usage,
  onSelect,
  sheetNumber,
  approved,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleClick = () => {
    if (usage === "timesheet") {
      onSelect(user._id);
    }
  };

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const onDragStart = (e) => {
    const startTime = new Date();
    startTime.setUTCHours(8, 0, 0, 0); // 08:00 AM

    // Create endTime with 17:00
    const endTime = new Date();
    endTime.setUTCHours(17, 0, 0, 0);

    const sendDataToCell = {
      type: "create",
      data: {
        userID: user._id,
        startTime,
        endTime,
      },
    };

    e.dataTransfer.setData("application/json", JSON.stringify(sendDataToCell));
  };

  return (
    <>
      <div
        draggable
        onDragStart={onDragStart}
        className={`flex rounded-l-md  items-center px-4 py-1 cursor-pointer 
          ${usage == "timesheet" && approved && "border-l-4 border-green-600"}
          ${
            usage == "timesheet" &&
            !approved &&
            sheetNumber !== "0hrs / 0 shifts" &&
            "border-l-4 border-orange-600"
          }          
          ${
            usage == "timesheet" &&
            sheetNumber === "0hrs / 0 shifts" &&
            "border-l-4 border-gray-200"
          }          
          ${
            user._id === selectedUserID
              ? "!border-l-4 !border-blue-600 text-gray-900 "
              : "text-slate-700"
          }`}
        onClick={handleClick}
      >
        <UserAvatar onClick={handleOpenDialog} user={user} />
        <div className="ml-3">
          <div className="font-semibold">{user.preferredName}</div>
          {sheetNumber == 0 ? (
            <div className="text-xs text-gray-600">No sheets</div>
          ) : (
            <div className="text-xs text-gray-600">{sheetNumber}</div>
          )}
        </div>
      </div>

      {/* Dialog Modal */}
      {isDialogOpen && (
        <UserProfileDialog
          onClose={() => setIsDialogOpen(false)}
          userID={user._id}
        />
      )}
    </>
  );
};

export default UserElement;
